module.exports = "<div class=\"background\">\n  <div class=\"wrapper\">\n    <div class=\"spinner\">\n      <div class=\"cube1\"></div>\n      <div class=\"cube2\"></div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/loading/loading.component.html
// module id = ./src/app/auth/loading/loading.component.html
// module chunks = main